import Page, { PageTab } from "../../shared/components/Page";
import HhaxPocMappingTable from "./HhaxPocMappingTable";
import SandataPocMappingTable from "./SandataPocMappingTable";

// Page.Tabbed renders its panels with no padding, so each tab supplies the same Page.Content
// padding the payer-scoped route gets. Without this the tables sit flush against the card edge.
const tabs: PageTab[] = [
  {
    header: "Sandata",
    route: "app.evv.dutyCodeMapping",
    component: (
      <Page.Content>
        <SandataPocMappingTable />
      </Page.Content>
    ),
  },
  {
    header: "HHAeXchange",
    route: "app.evv.dutyCodeMapping.hhax",
    component: (
      <Page.Content>
        <HhaxPocMappingTable />
      </Page.Content>
    ),
  },
];

export default function EvvDutyCodeMappingRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
